var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.topicList),function(item,index){return _c('van-swipe-item',{key:index,attrs:{"default":index}},[_c('img',{staticStyle:{"margin":"10px auto","display":"block","border-radios":"10px"},attrs:{"width":"94.6%","height":"100px","src":item.bannerUrl,"alt":"","srcset":""},on:{"click":function($event){return _vm.$router.push({
					path: '/topicDetail',
					query: { topicId: item.id, title: item.title }
				})}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }